import { View } from "binder"
import { TranslatorEditorViewModel } from "./translatorEditor-viewModel"

export class TranslatorEditorView extends View<TranslatorEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-034B7989-C7C7-4C77-9210-B48B35102A67"
    }
    loadHtml(): string {
        let element = require('./translatorEditor.html').default;
        let style = require('./translatorEditor.less');
        return element;
    }
    constructor() {
       super();
    }

    public set processName(v: string) { this._processName = v; } public get processName(): string { return this._processName;} private _processName: string;
    public set enumName(v: string) { this._enumName = v; } public get enumName(): string { return this._enumName;} private _enumName: string;

    edit(){
        this.dataContext.edit();
    }
}
